module.exports = __webpack_public_path__ + "img/text.6d2655d5.png";